import { FETCH_POSINFO_FAILURE, FETCH_POSINFO_REQUEST, FETCH_POSINFO_SUCCESS } from "../actions/types";

const initialState = {
    data: {},
    error: ''
};

export const posPosInfoReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_POSINFO_REQUEST:
            return {
                ...state,
            }
        case FETCH_POSINFO_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_POSINFO_FAILURE:
            return {
                data: {},
                error: action.payload
            }
        default:
            return state;
    }
}